import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Promotions Container Component
 *
 * Main container for promotion management with routing between list and editor (M3 Wave 6)
 *
 * @package WooAIChatbot
 */
import { useState } from 'react';
import { PromotionList, PromotionEditor } from './Promotions/index';
/**
 * Promotions Container Component
 */
export function PromotionsContainer() {
    const [viewMode, setViewMode] = useState({ type: 'list' });
    const handleCreate = () => {
        setViewMode({ type: 'create' });
    };
    const handleEdit = (promotionId) => {
        setViewMode({ type: 'edit', promotionId });
    };
    const handleBack = () => {
        setViewMode({ type: 'list' });
    };
    if (viewMode.type === 'create') {
        return _jsx(PromotionEditor, { onBack: handleBack });
    }
    if (viewMode.type === 'edit') {
        return (_jsx(PromotionEditor, { promotionId: viewMode.promotionId, onBack: handleBack }));
    }
    return (_jsx(PromotionList, { onCreate: handleCreate, onEdit: handleEdit }));
}
export default PromotionsContainer;
